var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RequestsReceivedWebReportPage',{attrs:{"mode":"sales_manager"}})
}
var staticRenderFns = []

export { render, staticRenderFns }